module.exports = __webpack_public_path__ + "img/eyes_open.c2426e22.svg";